import React from 'react';
import './SpinnerComponent.css';

const SpinnerComponent = ({ 
    isVisible = false, 
    message = "Processing...", 
    size = "medium",
    overlay = true 
}) => {
    if (!isVisible) return null;

    const spinnerContent = (
        <div className={`spinner-content spinner-size-${size}`}>
            <div className="rotating-spinner"></div>
            {message && <div className="spinner-message">{message}</div>}
        </div>
    );

    if (overlay) {
        return (
            <div className="spinner-overlay">
                {spinnerContent}
            </div>
        );
    }

    return (
        <div className="spinner-inline">
            {spinnerContent}
        </div>
    );
};

export default SpinnerComponent;